import LandingTemplate from '@/components/templates/LandingTemplate';

const VerifyEmailPage = () => {
  return (
    <LandingTemplate>
      <div></div>
    </LandingTemplate>
  );
};

export default VerifyEmailPage;
